/**
 * Positions that fill a FLEX slot. Settings hardcode flex as RB/WR/TE today —
 * single source of truth if that ever becomes configurable.
 */
export const FLEX_ELIGIBLE = ["RB", "WR", "TE"];

/**
 * Shared player list filter: position Set + search string.
 * Supports special "★" filter value — pass watchlist Set to enable.
 * Supports special "FLEX" filter value — expands to FLEX_ELIGIBLE.
 * Each hook applies its own sort after calling this.
 */
export function filterPlayerList(players, posFilter, search, watchlist) {
  let list = players;
  if (posFilter.has("★")) {
    list = watchlist ? list.filter(p => watchlist.has(p.name)) : [];
  } else if (!posFilter.has("ALL")) {
    const flex = posFilter.has("FLEX");
    list = list.filter(p => posFilter.has(p.pos) || (flex && FLEX_ELIGIBLE.includes(p.pos)));
  }
  if (search) {
    const s = search.toLowerCase();
    list = list.filter(p =>
      p.name.toLowerCase().includes(s) ||
      (p.team && p.team.toLowerCase().includes(s))
    );
  }
  return list;
}
